<!-- Translated: no -->
<template>
  <div class="country-switcher">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/css/flag-icon.min.css" />

    <div class="component dropdown" v-if="type === 'dropdown'">
      <div class="title" v-if="showTitle">
        <b>Select your country</b>
      </div>

      <div>
        <Dropdown
          :options="countries"
          :validated="selectedCountry && selectedCountry.value"
          :value="selectedCountry ? selectedCountry.value : null"
          :label="label"
          :with-background="false"
          @changed="changedCountry"
          :bold-label="true"
          type="cleanlarge"
          :allow-empty="false"
          :combo="false"
          >
        </Dropdown>
      </div>
    </div>

  </div>
</template>

<script>
import API from '@/classes/API';
import Dropdown from '@/components/components/Dropdown';

import languageDetector from '@/mixins/languageDetector';

export default {
  props: {
    type: {
    },
    showTitle: {
      default: true,
    },
  },
  components: {
    Dropdown,
  },
  data() {
    return {
      countries: [],
      pickedCountry: false,
      selectedCountry: {},
    };
  },
  mixins: [languageDetector],
  computed: {
    label() {
      if (this.selectedCountry && this.selectedCountry.value) {
        return this.selectedCountry.title; // eslint-disable-line
      }
      return 'Select country';
    },
  },
  async beforeMount() {
    let country = 'SE';

    if (localStorage.getItem('country')) {
      country = localStorage.getItem('country');
    } else {
      country = this.theCurrentCountry;
    }

    const data = await API.get('countries');
    this.countries = data;

    this.setCountry(this.countries.filter(item => item.value === country)[0]);
  },
  methods: {
    async setCountry(lang) {
      this.selectedCountry = lang;
      this.$emit('clickedcountry', lang.value);

      localStorage.setItem('country', lang.value);

      const data = await API.get('translations');
      try {
        this.$i18n.setLocaleMessage(lang.value, data.translations);
      } catch (e) {
        console.log(e);
      }

      window.SITE_CONFIG.translations = data.translations;

      try {
        this.$i18n.locale = lang.value;
      } catch (e) {
        console.log(e);
      }

      document.querySelector('html').setAttribute('lang', lang.value);

      this.pickedCountry = true;
      this.$emit('pickedcountry', lang.value);
    },
    async changedCountry(lang) {
      await this.setCountry(lang);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.component.row
  .title
    color white
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    b
      margin-bottom: 4px
    span
      margin-bottom: 0

  .countries
    display: flex;
    margin-top 20px
    margin-bottom 20px
    .country
      padding 5px
      background-color: rgba(255, 255, 255, 0.2)
      margin 15px
      cursor: pointer;
      transition: all 0.2s
      opacity: 0.4;
      &.active
        opacity: 1;
      &:hover
        background-color: rgba(255, 255, 255, 0.5)
      .flag
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        height: 28px
        width: 40px

.component.dropdown
  text-align: left
  margin-bottom: 25px
  .title
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 0
    font-size: 9px;
    b
      margin-bottom: 4px
    span
      margin-bottom: 0

.max-width
  width 250px
  display: inline-block;
  text-align: left

</style>



// WEBPACK FOOTER //
// CountrySwitcherNormal.vue?19e28c3c